import { LoadingAndErrors } from 'components/LoadingAndErrors';
import { useSSOCallback } from 'features/sso/hooks/useSSOCallback';
import { useQueryParams } from 'hooks/useQueryParms';
import { enqueueSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { registerDeviceWithWatchDuty } from 'shared/device';
import { useAuthState } from 'state/useAuthState';
import * as Sentry from '@sentry/capacitor';
import { History } from 'history';

const handleLoginError = (
  history: History,
  errorMessage: string,
  params: Record<string, string | null>,
): void => {
  const { code, ...extra } = params;
  Sentry.captureMessage('SSO login failed', {
    level: 'warning',
    extra: {
      ...extra,
    },
  });
  enqueueSnackbar(errorMessage, { variant: 'error' });
  history.replace('/login');
};

export const SSOCallback = (): JSX.Element | null => {
  const history = useHistory();
  const { loginSuccess } = useAuthState();
  const [params] = useQueryParams();

  useSSOCallback({
    params,
    onSuccess: (data) => {
      loginSuccess(data.key, data.user);
      registerDeviceWithWatchDuty({ user: data.user });
      history.replace(`/`);
    },
    onError: (message: string) => {
      handleLoginError(history, message, params);
    },
  });

  return <LoadingAndErrors isLoading />;
};
